module.exports = __webpack_public_path__ + "img/check-solid.154bb3fa.svg";